import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ServerFormErrorService {
  private backendFormControlError = signal<any>(null);
  serverError = this.backendFormControlError.asReadonly();
  setServerError(error: any) {
    this.backendFormControlError.set(error);
  }
  clearServerError() {
    this.backendFormControlError.set(null);
  }
}
